<div class="wrapper">
  <mat-sidenav-container class="Maincontainer">
    <mat-sidenav class="sidenav" #sidenav mode="over">
      <div class="header">
        <img src="assets/belairtrip_assets/main/belairtrip.svg" alt="Belairtrip.com">
        <mat-icon class="cut" (click)="sidenav.toggle()">close</mat-icon>
      </div>
      <div class="userArea">
        <div class="userPicture">
          <span *ngIf="!isLoggedIn" class="material-icons">person</span>
          <ng-container *ngIf="isLoggedIn">
            <ng-template #noImage>
              <span >{{util.getUser().slice(0, 1) | titlecase}}</span>
            </ng-template>
            <img mat-image *ngIf="profile_image(); else noImage" [src]="profile_image() | removeHttp" class="img-fluid headerProfileImg"/>
          </ng-container>
        </div>
          <div class="userName" *ngIf="!isLoggedIn">
            <a (click)="login(); sidenav.close()">Login/Sign Up</a>
          </div>
          <span *ngIf="isLoggedIn">{{util.getUser() | titlecase}}</span>
          <ng-container *ngIf="COPT.isCorporateUser()">
            <ng-container *ngIf="isLoggedIn">
              <div class="copt_amount">
                <p [ngStyle]="{ color: balance === 0 ? 'red' : 'inherit' }">Total Balance: <span>{{ balance | currency:'INR':'symbol':'1.0-2':'en-IN' }}</span></p>
              </div>
            </ng-container>
          </ng-container>
        </div>
      <span class="divider"></span>
      <ng-container *ngFor="let item of SideNavItems  | corporateFilter:COPT.isCorporateUser()">
        <ng-container *ngIf="!isLoggedIn">
          <button mat-menu-item (click)="login(); sidenav.close()" routerLinkActive="active" class="profileMenuButton">
            <mat-icon color="primary">{{item.icon}}</mat-icon>
            <div class="content">
              <span>{{item.label}}</span><br>
              <!-- <p class="descrip">{{item.content}}</p> -->
            </div>
          </button>
        </ng-container>
        <ng-container *ngIf="isLoggedIn">
          <button mat-menu-item [routerLink]="item.path" (click)="sidenav.close()" routerLinkActive="active" class="profileMenuButton">
            <mat-icon color="primary">{{item.icon}}</mat-icon>
            <div class="content">
              <span>{{item.label}}</span><br>
              <!-- <p class="descrip">{{item.content}}</p> -->
            </div>
          </button>
        </ng-container>
        <span class="divider"></span>
      </ng-container>
      <button mat-menu-item (click)="logOut()"  *ngIf="isLoggedIn">
        <mat-icon color="primary">logout</mat-icon>
        <span>Logout</span>
      </button>
      <!-- <span class="divider"></span> -->
       <div class="hraderSupport currencyMenu d-none">
        <mat-accordion color="primary" [matMenuTriggerFor]="currencyMenu" (click)="sidenav.close()" >
          <span class="d-flex">
            <!-- <ng-container>&nbsp;&nbsp;{{this.currencySelected.shortname}}&nbsp;&nbsp;({{this.currencySelected.symbol}})</ng-container> -->
            <mat-icon>expand_more</mat-icon>
          </span>
        </mat-accordion>
        <mat-menu #currencyMenu class="matmainmenu">
          <ng-container *ngFor="let item of currency">
            <button mat-menu-item (click)="select(item)">
              <mat-icon color="primary">{{item.symbol}}</mat-icon>
              <span>{{item.name | titlecase}}({{item.shortname}})</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
      <div class="hraderSupport d-sm-block">
        <!-- <span class="d-flex" [matMenuTriggerFor]="supportMenu"  >
          Support <mat-icon>expand_more</mat-icon>
        </span> -->
        <mat-card class="support-card">
          <a mat-menu-item href="mailto:support@belairtrip.com" class="support-button">
            <mat-icon color="primary">email</mat-icon>
            <span>support&#64;belairtrip.com</span>
          </a>
          <div class="divider"></div>
          
          <!-- <a mat-menu-item class="support-button" href="tel:+01142521000">
            <mat-icon color="primary">call</mat-icon>
            <span>+91-9015776677</span>
          </a> -->
          <div class="divider"></div>
          
          <a mat-menu-item class="support-button teleicon" href="tel:+91-9355019962">
            <img src="../../../../assets/belairtrip_assets/main/female-services-support-icon.png" alt="Belairtrip.com Support" class="icon-img">
            <span>+91-9355019962</span>
          </a>
        </mat-card>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-icon class="menuIcon" (click)="sidenav.toggle()">menu</mat-icon>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
